import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../../school_panel/components/ui';

interface Props {
  /** Omitted on the first step. */
  onBack?: () => void;
  /** Short status line derived from the wizard state. */
  note?: ReactNode;
  /** The step's primary action. */
  children?: ReactNode;
}

/** Step card footer: Back on the left, a status note, the step's own primary action on the right. */
export default function RagStepFooter({ onBack, note, children }: Props) {
  return (
    <div className="mt-[22px] flex flex-wrap items-center justify-between gap-2.5 border-t border-hairline pt-[18px]">
      {onBack ? (
        <Button type="button" variant="ghost" onClick={onBack} icon={<ArrowLeft size={16} aria-hidden />}>Back</Button>
      ) : <span />}
      {note ? <span className="text-[13px] text-muted">{note}</span> : null}
      {children}
    </div>
  );
}
